// extracted by mini-css-extract-plugin
export default {"container":"_37qLCk","tablist":"_2riNkJ","tab":"_1PjI9f","selected":"_2e3qSq","tabpannel":"_1KGuci","selectedTabPanel":"_1bfZhT"};